import React from "react"
import { Helmet } from "react-helmet"
import Layout from "../../../components/Layout"
import Header from "../../../components/Header"
import CaseStudy, {
  CASE_STUDY_TYPES,
} from "../../../components/case-study/CaseStudy"
import ThumbnailImage from "../../../images/thumbnails/saasboomi_thumb.png"

export function Index() {
  return (
    <Layout
      title="SaaSBOOMi Real-Time Attendee Engagement Success with Premagic AI Photos"
      description="SaaSBOOMi achieved exceptional real-time attendee engagement and community building through AI-powered photo sharing at startup and SaaS events."
      metaImage={ThumbnailImage}
      keywords={[
        "SaaSBOOMi case study, SaaS community events, Indian SaaS ecosystem, startup conference photos, SaaS networking events, tech entrepreneur events, SaaS community building, startup photo sharing, Indian startup events, SaaS founder networking, tech community engagement, startup ecosystem events, SaaS conference technology, entrepreneur community photos, Indian tech startups",
      ]}
      breadcrumbs={[
        { name: "Home", url: "/" },
        { name: "Case Studies", url: "/case-study/" },
        { name: "SaaSBOOMi", url: "/case-study/saasboomi/" },
      ]}
    >
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Article",
            "headline": "SaaSBOOMi Real-Time Attendee Engagement Success with Premagic AI Photos",
            "description": "SaaSBOOMi achieved exceptional real-time attendee engagement and community building through AI-powered photo sharing at startup and SaaS events.",
            "image": "https://premagic.com" + ThumbnailImage,
            "author": {
              "@type": "Organization",
              "name": "Premagic",
            },
            "publisher": {
              "@type": "Organization",
              "name": "Premagic",
              "logo": {
                "@type": "ImageObject",
                "url": "https://premagic.com/icons/icon-144x144.png",
              },
            },
            "datePublished": "2024-01-15",
            "dateModified": "2025-01-15",
          })}
        </script>
      </Helmet>
      <Header />
      <CaseStudy type={CASE_STUDY_TYPES.SAASBOOMI} />
    </Layout>
  )
}

export default Index
